/**
 * Artency Wishlist — LocalStorage & Metafield hybrid
 */
(function () {
  var STORAGE_KEY = 'artency_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(
      new CustomEvent('wishlist:change', { detail: { list: list, count: list.length } })
    );
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function (h) {
      return h !== handle;
    });
    saveWishlist(list);
  }

  // Update UI logic
  function updateUI() {
    var list = getWishlist();

    // 1. Update butoane inima (cards + product page)
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        active ? (btn.dataset.labelRemove || 'Remove from favorites') : (btn.dataset.labelAdd || 'Add to favorites')
      );
    });

    // 2. Update counter global din header
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle('is-empty', list.length === 0);
    });

    // 3. Update counter de pe PAGINA DE PRODUS
    document.querySelectorAll('[data-wishlist-product-count]').forEach(function (el) {
      var handle = el.getAttribute('data-product-handle');
      var baseCount = parseInt(el.getAttribute('data-base-count') || '0', 10);
      var active = list.indexOf(handle) !== -1;

      // Daca utilizatorul are produsul salvat in localStorage, adaugam +1 la valoarea din metafield
      var finalCount = active ? baseCount + 1 : baseCount;
      el.textContent = finalCount;

      // Update text limba engleza (person / people)
      var labelEl = document.querySelector('[data-wishlist-product-label]');
      if (labelEl) {
        labelEl.textContent = finalCount === 1 ? 'person' : 'people';
      }

      // Afisam container-ul doar daca numarul este mai mare decat 0
      var container = document.getElementById('product-wishlist-counter');
      if (container) {
        container.style.display = finalCount > 0 ? 'inline-flex' : 'none';
      }
    });
  }

  // Event Delegation pentru Click
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;

    btn.classList.add('is-animating');
    setTimeout(function () {
      btn.classList.remove('is-animating');
    }, 260);

    toggleWishlist(handle);
  });

  document.addEventListener('wishlist:change', updateUI);

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) updateUI();
  });

  window.ArtencyWishlist = {
    get: getWishlist,
    has: isInWishlist,
    toggle: toggleWishlist,
    remove: removeFromWishlist,
    refresh: updateUI
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateUI);
  } else {
    updateUI();
  }
})();